import React from "react";
import content from "../data/results/2013content.json";
import resultData from "../data/2013data.json";
import ResultsPage from "./ResultsPage";

const Results2013 = () => <ResultsPage content={content} resultData={resultData} />;

export default Results2013;
